import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { useQuery } from 'react-query';
import RefreshCheckApi from '../../../communication_system/axios_apis/refresh_check/refresh_check_api';
import axios from 'axios';
import LoadingPage from '../../../pages/loading/LoadingPage';
import UserInfoModal from './UserInfoModal';
import {main_server_ip} from "../../../communication_system/communication_ips";

/** URL */
let url = 'https://senor.co.kr';

function CreatedGatheringUserInfoModal({ setToggle, refresh, gatheringId }) {
    const [myInfo, setMyInfo] = useState({});
    const adminCheckAPI = async () => {
        const reseponse = await RefreshCheckApi.get('/admin/check');
        const adminInfo = reseponse.data.info;
        setMyInfo(adminInfo);
    };

    useEffect(() => {
        adminCheckAPI();
    }, []);

    // state
    const [searchType, setSearchType] = useState(1);
    const [searchText, setSearchText] = useState('');
    const [userId, setUserId] = useState(0);
    const [role, setRole] = useState(1);
    const [userName, setUserName] = useState('');

    const [packagesData, setPackagesData] = useState([]);

    const [accessToken, setAccessToken] = useState('');
    const [payContents, setPayContents] = useState(null);
    const [payType, setPatType] = useState(1);

    const [loading, setLoading] = useState(false);

    // request param
    const [params, setParams] = useState({});

    // useRef
    const mainModal = useRef();

    // react-query
    const { isLoading, error, data, refetch } = useQuery(['userListsData'], async () => {
        let input = {
            size: 10,
            searchType: searchType,
            searchWord: searchText,
        };

        return await RefreshCheckApi.get('/adminUser', { params: input }).then((res) => {
            return {
                data: res.data.data,
            };
        });
    });

    useEffect(() => {
        setPackagesData(params?.package);
    }, [params]);

    // error 처리
    useEffect(() => {
        if (error) {
            alert(error);
        }
    }, [error]);

    // 성별 필터
    const sexFilter = (num) => {
        let _num = parseInt(num);

        if (_num === 1) {
            return '남자';
        } else if (_num === 2) {
            return '여자';
        } else {
            return <span style={{ color: 'gray' }}>NULL</span>;
        }
    };

    // 검색어
    const onChangeInput = (e) => {
        setSearchText(e.target.value);
    };

    // 검색 타입
    const onChangeSearchType = (e) => {
        setSearchType(e.target.value);
    };

    // 검색 요청
    const onChangeSubmit = (e) => {
        e.preventDefault();

        refetch();
    };

    // ! 해당 api는 어째서 어드민 id가 아닌 유저의 id로 토큰을 발급 받는지 확인이 불가능함.
    // 그리고, 해당 기능은 어드민 검증에선 당연히 안될 것이며, 유저 검증에선 필요없는 기능임.
    // 문제는, 로컬 및 개발 디비에서 유저 정보 또한 동기화가 안되기 때문에 로컬에서도 확인이 힘듬.
    /** 토큰 발급 받기 */
    const onClickGetToken = async (serverUrl, adminId) => {
        try {
            const _url = serverUrl || url;
            const response = await RefreshCheckApi.post(_url + '/auth/testLogin', {
                id: adminId ?? userId,
            });
            const token = response.data.data.access_token;
            setAccessToken(token);
            return token;
        } catch (error) {
            console.error('error: ', error);
        }
    };

    /** 회원선택 */
    const onClickSelectUser = (userData) => async () => {
        setAccessToken('');
        setUserId(userData.id);
        setUserName(userData.name);
    };

    const onClickCreateGatheringUser = () => {
        if (!userId)  {
            return alert('회원정보를 선택해주세요.');
        }

        onClickGetToken(main_server_ip, myInfo.id).then((token) => {
            setLoading(true);

            const response = axios.post(main_server_ip + '/adminGathering/join/user', {
                gatheringId: gatheringId,
                userId: userId,
                role: role,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            response
                .then((res) => {
                    setLoading(false);
                    setToggle(false);
                    refresh();
                    alert('유저 가입이 완료되었습니다.');
                })
                .catch((error) => {
                    console.error(error);
                    setLoading(false);
                    alert(`에러발생: ${error.response.data.message}`);
                });
        })
    };

    return (
        <DetailModalWrapper id="modal-window">
            <DetailModalBox id="modal-box" ref={mainModal}>
                <Header id="top-line">
                    <Text>모입 가입 초대</Text>
                    <Text style={{ cursor: 'pointer' }} onClick={() => setToggle(false)}>
                        닫기
                    </Text>
                </Header>

                {isLoading ? (
                    <LoadingPage text={'회원정보를 불러오고 있습니다.'} />
                ) : (
                    <ModalBoxBody>
                        <InfoBox className="subscribe-info">
                            {!userId ? (
                                <>
                                    <InfoTitle>회원</InfoTitle>

                                    <SearchWrapper type="submit">
                                        <Select onChange={onChangeSearchType}>
                                            <option value={1}>휴대폰번호</option>
                                            <option value={2}>이름</option>
                                            <option value={3}>닉네임</option>
                                        </Select>

                                        <form style={{ marginLeft: '5px' }} onSubmit={onChangeSubmit}>
                                            <Input type="text" placeholder="회원검색" onChange={onChangeInput} />
                                            <Button type="submit">검색</Button>
                                        </form>
                                    </SearchWrapper>

                                    <ColWrapper>
                                        <Subtitle>회원ID</Subtitle>
                                        <Subtitle>회원명</Subtitle>
                                        <Subtitle>성별</Subtitle>
                                        <Subtitle style={{ width: '85px' }}>생년월일</Subtitle>
                                        <Subtitle style={{ width: '95px' }}>휴대폰번호</Subtitle>
                                    </ColWrapper>

                                    <UserLists>
                                        {data?.data?.map((item, index) => {
                                            return (
                                                <ColWrapper02 key={index} onClick={onClickSelectUser(item)}>
                                                    <SubInfo>{item.id}</SubInfo>
                                                    <SubInfo>{item.name || <span style={{ color: 'gray' }}>NULL</span>}</SubInfo>
                                                    <SubInfo>{sexFilter(item.sex)}</SubInfo>
                                                    <SubInfo style={{ width: '85px' }}>{item.birthday || <span style={{ color: 'gray' }}>NULL</span>}</SubInfo>
                                                    <SubInfo style={{ width: '95px' }}>{item.phone_no || <span style={{ color: 'gray' }}>NULL</span>}</SubInfo>
                                                </ColWrapper02>
                                            );
                                        })}
                                    </UserLists>
                                </>
                            ) : (
                                <UserInfoModal userId={userId} setUserId={setUserId} setAccessToken={setAccessToken} setRole={setRole} />
                            )}
                        </InfoBox>
                    </ModalBoxBody>
                )}
                <ButtonWrapper style={{ textAlign: 'end' }}>
                    {
                        userId ? <Button02 onClick={() => onClickCreateGatheringUser()}>{loading ? '유저 추가 중...' : '유저 가입'}</Button02> : null
                    }
                </ButtonWrapper>
            </DetailModalBox>
        </DetailModalWrapper>
    );
}

export default CreatedGatheringUserInfoModal;

/************************************ styled ************************************/

const DetailModalWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 4;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: 100%;
    height: 100vh;

    background-color: #000000b0;
`;

const DetailModalBox = styled.div`
    position: relative;

    display: flex;
    flex-direction: column;
    justify-content: start;

    width: 100vh;
    height: 70vh;

    border-radius: 10px;
    background-color: #fff;

    @media (max-width: 912px) {
        width: 98%;
        height: 90vh;
    }

    .close-window {
        padding: 5px 25px;
        text-align: start;
        font-size: 20px;
        color: #428bf7;
    }

    .close-icon {
        position: absolute;
        top: 0;
        right: 0;

        padding: 15px;
        color: gray;
    }
`;

const Header = styled.div`
    z-index: 2;
    display: flex;
    justify-content: space-between;

    background-color: rgb(66, 139, 247);

    border-top-left-radius: 9px;
    border-top-right-radius: 9px;

    height: 5vh;

    align-items: center;

    @media (max-width: 1120px) {
        width: 100%;
    }
`;

const Text = styled.div`
    padding: 0 15px;

    color: #fff;
    font-size: 16px;
    font-weight: 600;

    line-height: 45px;
`;

const ModalBoxBody = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    height: 77vh;
    padding: 0 30px;
    overflow: auto;

    #label {
        display: none;
    }

    @media (max-width: 912px) {
        flex-direction: column;
    }
`;

const InfoBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: start;

    width: 100%;
    height: 100%;

    border-left: ${(props) => (props.leftLine ? '1px solid gray' : '')};
    padding-left: ${(props) => (props.leftLine ? '2%' : '')};
`;

const InfoTitle = styled.h2`
    margin: 8% 0 30px 0;

    font-size: 17px;
    font-weight: 600;
`;

const ColWrapper = styled.div`
    display: flex;
    align-items: center;

    padding: 0 1% 2% 1%;
`;

const ColWrapper02 = styled.div`
    cursor: pointer;
    user-select: none;

    display: flex;
    align-items: center;

    padding: 2% 1%;

    &:hover {
        background-color: #cccccc;
    }
`;

const UserLists = styled.div`
    width: 100%;
    height: 50vh;
    overflow: auto;
`;

const Subtitle = styled.div`
    font-size: 13px;
    color: gray;

    width: 60px;
`;

const SubInfo = styled.div`
    font-size: 13.5px;
    font-weight: 500;

    width: 60px;
`;

const SearchWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 1px;

    margin-bottom: 30px;
`;

const Select = styled.select`
    cursor: pointer;
    outline: none;

    border: 1px solid #cccccc;

    width: 90px;
    height: 25px;
`;

const Input = styled.input`
    outline: none;
    border: 1px solid #cccccc;

    padding: 1px 5px;
    height: 21px;

    ::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
`;

const Button = styled.button`
    cursor: pointer;
    border: 1px solid #cccccc;

    width: 50px;
    height: 25px;
`;

const ButtonWrapper = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;

    width: 100%;
`;

const Button02 = styled.button`
    cursor: pointer;

    border: 1px solid rgb(226, 0, 103);
    border-radius: 2px;

    background-color: rgb(255, 16, 125);
    color: #fff;

    margin: 2%;

    &:hover {
        background-color: rgb(226, 0, 103);
    }
`;
